import { FC } from 'react'
import { NonUndefined } from 'react-hook-form'

import LoadingButton from '@/components/loading-button'
import { ActionTimer } from '@/hooks/useActionTimer'
import { Logging } from '@/out/logging'

type Props = {
  configuration: NonUndefined<Logging['rapid7']>
  timer: ActionTimer
  onRemove: () => void
}

const Rapid7Details: FC<Props> = ({ configuration, timer, onRemove }) => {
  return (
    <div>
      <div className="pt-2 mb-6 space-y-3">
        <div className="flex flex-col space-y-1">
          <span className="text-sm text-muted-foreground">Webhook URL</span>
          <span title={configuration.webhookUrl} className="text-sm font-medium truncate">
            {configuration.webhookUrl}
          </span>
        </div>
      </div>
      <LoadingButton timer={timer} variant="outline-destructive" size="sm" onClick={onRemove}>
        Disconnect
      </LoadingButton>
    </div>
  )
}

export default Rapid7Details
